export const Popup = {
    /** UI SCREENS */
    ERROR_POPUP_APPUI: "ERROR_POPUP_APPUI",
    ERROR_POPUP_NETWORK: "ERROR_POPUP_NETWORK",
    /** PLAYER */
    ERROR_POPUP_PLAYER: "ERROR_POPUP_PLAYER"
}